import Messages from "../../../../components/messages/messages";
import { connect } from "react-redux";
export default connect(state => ({
  data: state.userMenu.messages
}))(Messages);
